import { Component, DestroyRef, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToasterPosition } from 'ng-angular-popup';
import { AppVisualContextService } from './shared/services/app-visual-context.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  @Input() title: string = '';

  toasterPosition = ToasterPosition;
  private accentClass = '';

  constructor(private visualContext: AppVisualContextService, private renderer: Renderer2,
    private destroyRef: DestroyRef, @Inject(DOCUMENT) private document: Document) {}

  ngOnInit(): void {
    this.visualContext.initialize();
    this.visualContext.accent$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(accent => {
      if (this.accentClass) this.renderer.removeClass(this.document.documentElement, this.accentClass);
      this.accentClass = this.visualContext.classForAccent(accent);
      this.renderer.addClass(this.document.documentElement, this.accentClass);
    });
    this.destroyRef.onDestroy(() => {
      if (this.accentClass) this.renderer.removeClass(this.document.documentElement, this.accentClass);
    });
  }
}
